/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_Cta_ContactInputs */

const en_directory_external_directories_cta_contact = /** @type {(inputs: Directory_External_Directories_Cta_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask about distribution`)
};

const zh_directory_external_directories_cta_contact = /** @type {(inputs: Directory_External_Directories_Cta_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`咨询代发布`)
};

/**
* | output |
* | --- |
* | "Ask about distribution" |
*
* @param {Directory_External_Directories_Cta_ContactInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_cta_contact = /** @type {((inputs?: Directory_External_Directories_Cta_ContactInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_Cta_ContactInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_cta_contact(inputs)
	return zh_directory_external_directories_cta_contact(inputs)
});
export { directory_external_directories_cta_contact as "directory.external_directories.cta.contact" }